import React from "react";
import { UserBlockIcon } from "modules/icons";
import useStyles from "./styles";

type BlockButtonProps = {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  size?: "small" | "medium" | "big";
  title?: string;
};

export const BlockButton: React.FC<BlockButtonProps> = ({
  onClick,
  size = "medium",
  title,
}) => {
  const { classes, cx } = useStyles();

  const sizeClass =
    size === "small"
      ? classes.buttonSmall
      : size === "big"
      ? classes.buttonBig
      : classes.buttonMedium;

  return (
    <button
      title={title}
      className={cx(classes.blockButton, classes.button, sizeClass)}
      onClick={(e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onClick(e);
      }}
    >
      <span>
        <UserBlockIcon />
      </span>
    </button>
  );
};
